import React from "react";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";

export function Privacy() {
  return (
    <div className="min-h-screen bg-[#0a0a12]">
      <Header />
      <main className="pt-32 pb-20 px-6">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-bold text-white mb-2">Privacy Policy</h1>
          <p className="text-sm text-[#5a4a7a] mb-10">Last updated: March 4, 2026</p>

          <div className="space-y-8 text-[#b0a0c0] leading-relaxed">
            <section>
              <h2 className="text-xl font-semibold text-white mb-3">1. Information We Collect</h2>
              <p className="mb-3">When you use Onyx AI, we may collect the following information:</p>
              <ul className="list-disc list-inside space-y-1.5 text-[#8a7a9a]">
                <li>Account information (email, name, company name)</li>
                <li>Chat conversation data between your customers and the AI/agents</li>
                <li>Usage analytics and platform interaction data</li>
                <li>Payment information processed securely through Stripe</li>
                <li>Technical data (IP addresses, browser type, device information)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">2. How We Use Your Information</h2>
              <ul className="list-disc list-inside space-y-1.5 text-[#8a7a9a]">
                <li>To provide and maintain our chatbot service</li>
                <li>To process your subscription and billing</li>
                <li>To improve AI response quality and accuracy</li>
                <li>To send important service updates and notifications</li>
                <li>To provide customer support</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">3. Data Storage & Security</h2>
              <p>
                Your data is stored on secure servers with encryption at rest and in transit.
                We implement industry-standard security measures including JWT authentication,
                rate limiting, and regular security audits. Chat data is retained for the duration
                of your subscription and deleted upon account termination upon request.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">4. Third-Party Services</h2>
              <p className="mb-3">We use the following third-party services:</p>
              <ul className="list-disc list-inside space-y-1.5 text-[#8a7a9a]">
                <li><span className="text-[#b0a0c0]">OpenAI</span> — for AI-powered chat responses</li>
                <li><span className="text-[#b0a0c0]">Stripe</span> — for payment processing</li>
              </ul>
              <p className="mt-3">
                These providers have their own privacy policies and we encourage you to review them.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">5. Your Rights</h2>
              <p>You have the right to:</p>
              <ul className="list-disc list-inside space-y-1.5 text-[#8a7a9a] mt-2">
                <li>Access your personal data</li>
                <li>Request correction of inaccurate data</li>
                <li>Request deletion of your data</li>
                <li>Export your conversation data</li>
                <li>Opt out of non-essential communications</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">6. Cookies</h2>
              <p>
                We use essential cookies for authentication and session management. We do not use
                third-party tracking cookies or advertising cookies.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">7. Contact</h2>
              <p>
                For privacy-related inquiries, contact us at{" "}
                <a href="mailto:hello.onyx@cloudforge.com.my" className="text-[#c0a0e0] hover:underline">
                  hello.onyx@cloudforge.com.my
                </a>
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
